import React, {useState} from "react"
import {Button, Message, Modal, Table} from "antd"
import {fetchChangeTable} from "../../../api/clubReserve"
import moment from "moment"

const recordDetail = ({id}) => {

    const [isShow, setIsShow] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [changeTable, setChangeTable] = useState([])

    const getTableChange = async () => {
        setIsShow(true)
        setIsLoading(true)
        const res = await fetchChangeTable(id)
        if (res) {
            const data = res.data.map(item => {
                return {
                    createTime: moment(item.tableChange.createTime).format('YYYY-MM-DD HH:mm:ss'),
                    oldTable: item.sourceTable.name,
                    newTable: item.targetTable.name,
                    operator: item.tableChange.operator
                }
            })
            setChangeTable(data)
        } else {
            Message.error('获取数据失败')
        }
        setIsLoading(false)
    }

    const handleCancel = () => {
        setIsShow(false)
    }

    const handleOk = () => {
        setIsShow(false)
    }

    const columns = [
        {
            title: '时间',
            dataIndex: 'createTime',
            key: 'createTime'
        },
        {
            title: '原球台',
            dataIndex: 'oldTable',
            key: 'oldTable'
        },
        {
            title: '新球台',
            dataIndex: 'newTable',
            key: 'newTable'
        },
        {
            title: '操作人',
            dataIndex: 'operator',
            key: 'operator'
        }
    ]

    return (
        <div>
            <Button onClick={getTableChange} type={"primary"}>换台记录</Button>
            <Modal
                title="换台记录"
                open={isShow}
                onOk={handleOk}
                onCancel={handleCancel}
                width="600px"
            >
                <Table dataSource={changeTable} columns={columns} loading={isLoading}/>
            </Modal>
        </div>
    )

}

export default recordDetail


// WEBPACK FOOTER //
// ./src/containers/ClubReserve/components/recordDetail.js